const initialState = {
    outletName: '',
    outletId: '',
    companyCode: ''
};
export default (state = initialState, action) => {
    // 
    // console.log("action", action)
    // console.log("action", state)

    switch (action.type == "AMINTOMNR" || action.type == "RESET") {
        case 'AMINTOMNR':
            state = {
                ...state,
                outletName: action.outletName,
                outletId: action.outletId,
                companyCode: action.companyCode
            };
            break;
        case 'RESET':
            state = initialState;
            break;
    }
    return state;


}